// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"90d71455","935":"bd7efd91"}[chunkId] + ".chunk.css";
};